import React from "react";
import {AodIcon} from "../AodUi/AodIcon";

export default function Help(){
    return <div style={{padding: 10}}>
        <p>
            I did write you some notes but then I thought better of it.<br/>
            If you can't figure it out it probably needs changing...
        </p>
        <p>
            <AodIcon type={'account'}/> Account (YP)<br/>
            <AodIcon type={'advertiser'}/> Advertiser<br/>
            <br/>
            <AodIcon type={'salesSheet'}/> Presentation (Advertiser Project)<br/>
            <AodIcon type={'specAd'}/> Spec Ad<br/>
            <br/>
            <AodIcon type={'template'}/> Template<br/>
            <AodIcon type={'artwork'}/> Advertiser Artwork<br/>
            <br/>
            <AodIcon type={'salesRep'}/> Sales Rep<br/>
            <AodIcon type={'contact'}/> Advertiser Contact (don't have these in the UI yet)<br/>
            <AodIcon type={'creator'}/> regular user/creator<br/>

        </p>
        <div style={{display:'none'}}>
        <h4>Notes for Customer Service</h4>
        <p>This new "AOD Wizard" use the idea of the current wizards steps and blends them with the SalesSheet & Spec Ad ideas of the old MiAD Mobile App</p>
        <p>The wizard can be used to just create ads and share them like the current wizard.  However any ad that is shared or downloaded will trigger a save dialog.</p>
        <p>Spec Ads are saved into a Presentation that is stored by advertiser.
            Presentations can be thought of as advertiser projects just for storing spec ads, which are shared with all users in the account </p>
        <br/>
        <p>Because this wizard is backed by an AOD system advertisers can be saved and re-used.  A logo can be uploaded for each advertiser and placed on  the ad in step 4. </p>
        <p>Step 3 operates like the MiAD panel and allows users to alter the size of the ad.</p>
        <br/>
        <p>The Presentation & Spec Ad tab can be used to find saved ads & sheets.  Saved ads can be re-shared or downloaded.</p>
        <p>Its' also possible to add more spec ads to a presentation.  Spec ads can't be edited - just make another one.</p>
        <br/>
        <p>Sales Rep means the owner of the presentation and  for now thats the same as the user who created the it. </p>
        </div>
    </div>
}